import { GalleryContainer, GalleryItem } from "Gallery/style";
import { Image } from "Image";
import { useState } from "react";
import { direction } from "Util/direction";
import { ExpandGalleryButton, ExpandGalleryButtonContainer } from "./style";

export const GalleryRenderer = ({ name, setImgSrc, images }) => {
  const [itemLength, setItemLength] = useState(8);

  return (
    <>
      <GalleryContainer>
        {images.map(
          (img, idx) =>
            idx < itemLength && (
              <GalleryItem>
                <Image
                  key={`${name}-img-${idx}`}
                  setImgSrc={setImgSrc}
                  direction={img.direction ?? direction.portrait}
                  thumbnailSrc={img.thumbnail}
                  originalSrc={img.original}
                  width={"100%"}
                />
              </GalleryItem>
            )
        )}
        {itemLength !== images.length && (
          <ExpandGalleryButtonContainer>
            <ExpandGalleryButton onClick={() => setItemLength(images.length)}>
              Weitere Bilder laden...
            </ExpandGalleryButton>
          </ExpandGalleryButtonContainer>
        )}
      </GalleryContainer>
    </>
  );
};
